import React from "react";
import "./ourValues.css";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import TabsPanel from "./TabsPanel";
import Tab from "./Tab";
import synergyImage from "../../assets/synergy.jpg";
import optimizedImage from "../../assets/optimizedSolutions.jpg";
import operationalImage from "../../assets/operationalExcellance.jpg";
import reliabilityImage from "../../assets/reliability.jpg";
import innovationImage from "../../assets/innovation.jpg";

const OurValues = () => {
  return (
    <>
      <div className="values-wrapper">
        <div className="section-title">
          <h1 className="title">The Soori Commitment</h1>
          <span className="subtitle" aria-hidden="true">
            <AutoTyping
              active // <boolean>
              textRef={"Our Values"}
              writeSpeed={150} // <number>
              deleteSpeed={150} // <number>
              delayToWrite={1000} // <number>
              delayToDelete={2000}
            />
          </span>
        </div>
        <div className="values-details-container">
          <div className="values-details">
            <TabsPanel>
              <Tab
                title="S"
                subtitle="Synergy"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <mask id="ipTGreenNewEnergy0">
                        <g
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path d="M42.336 16C39.249 8.936 32.2 4 24 4S8.75 8.936 5.664 16" />
                          <path
                            fill="#555"
                            d="M24 14a19.94 19.94 0 0 0-6 14.283q0 .75.055 1.488A19.94 19.94 0 0 1 24 44a19.94 19.94 0 0 1 5.945-14.23q.055-.736.055-1.487A19.94 19.94 0 0 0 24 14"
                          />
                          <path
                            fill="#555"
                            d="M4 24c0 11.046 8.954 20 20 20a19.94 19.94 0 0 0-5.945-14.23A19.94 19.94 0 0 0 4 24"
                          />
                          <path
                            fill="#555"
                            d="M44 24c0 11.046-8.954 20-20 20a19.94 19.94 0 0 1 5.945-14.23A19.94 19.94 0 0 1 44 24"
                          />
                        </g>
                      </mask>
                    </defs>
                    <path
                      fill="#494B50"
                      d="M0 0h48v48H0z"
                      mask="url(#ipTGreenNewEnergy0)"
                    />
                  </svg>
                }
                style={{ color: "#bf202f" }}
                image={synergyImage}
              >
                At Soori Corporation, we believe in the power of collaboration
                and teamwork. By bringing together diverse skills and
                perspectives, we create more innovative and effective solutions
                than any single individual could. This synergy helps us deliver
                technology that truly meets the needs of our clients.
              </Tab>
              <Tab
                title="O"
                subtitle="Optimized Solutions"
                image={optimizedImage}
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <mask id="ipTGreenNewEnergy0">
                        <g
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path d="M42.336 16C39.249 8.936 32.2 4 24 4S8.75 8.936 5.664 16" />
                          <path
                            fill="#555"
                            d="M24 14a19.94 19.94 0 0 0-6 14.283q0 .75.055 1.488A19.94 19.94 0 0 1 24 44a19.94 19.94 0 0 1 5.945-14.23q.055-.736.055-1.487A19.94 19.94 0 0 0 24 14"
                          />
                          <path
                            fill="#555"
                            d="M4 24c0 11.046 8.954 20 20 20a19.94 19.94 0 0 0-5.945-14.23A19.94 19.94 0 0 0 4 24"
                          />
                          <path
                            fill="#555"
                            d="M44 24c0 11.046-8.954 20-20 20a19.94 19.94 0 0 1 5.945-14.23A19.94 19.94 0 0 1 44 24"
                          />
                        </g>
                      </mask>
                    </defs>
                    <path
                      fill="#494B50"
                      d="M0 0h48v48H0z"
                      mask="url(#ipTGreenNewEnergy0)"
                    />
                  </svg>
                }
              >
                Our focus is on providing solutions that are specifically
                designed to enhance efficiency and effectiveness. We tailor our
                technology to fit the unique requirements of each client,
                ensuring that our solutions are not just effective but also
                optimized for their particular needs.
              </Tab>
              <Tab
                title="O"
                subtitle="Operational Excellence"
                image={operationalImage}
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <mask id="ipTGreenNewEnergy0">
                        <g
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path d="M42.336 16C39.249 8.936 32.2 4 24 4S8.75 8.936 5.664 16" />
                          <path
                            fill="#555"
                            d="M24 14a19.94 19.94 0 0 0-6 14.283q0 .75.055 1.488A19.94 19.94 0 0 1 24 44a19.94 19.94 0 0 1 5.945-14.23q.055-.736.055-1.487A19.94 19.94 0 0 0 24 14"
                          />
                          <path
                            fill="#555"
                            d="M4 24c0 11.046 8.954 20 20 20a19.94 19.94 0 0 0-5.945-14.23A19.94 19.94 0 0 0 4 24"
                          />
                          <path
                            fill="#555"
                            d="M44 24c0 11.046-8.954 20-20 20a19.94 19.94 0 0 1 5.945-14.23A19.94 19.94 0 0 1 44 24"
                          />
                        </g>
                      </mask>
                    </defs>
                    <path
                      fill="#494B50"
                      d="M0 0h48v48H0z"
                      mask="url(#ipTGreenNewEnergy0)"
                    />
                  </svg>
                }
              >
                We are committed to maintaining high standards in every aspect
                of our operations. From the initial development of our products
                to their implementation and support, we strive for excellence to
                ensure that our technology works seamlessly and delivers
                superior performance.
              </Tab>
              <Tab
                title="R"
                subtitle="Reliability"
                image={reliabilityImage}
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <mask id="ipTGreenNewEnergy0">
                        <g
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path d="M42.336 16C39.249 8.936 32.2 4 24 4S8.75 8.936 5.664 16" />
                          <path
                            fill="#555"
                            d="M24 14a19.94 19.94 0 0 0-6 14.283q0 .75.055 1.488A19.94 19.94 0 0 1 24 44a19.94 19.94 0 0 1 5.945-14.23q.055-.736.055-1.487A19.94 19.94 0 0 0 24 14"
                          />
                          <path
                            fill="#555"
                            d="M4 24c0 11.046 8.954 20 20 20a19.94 19.94 0 0 0-5.945-14.23A19.94 19.94 0 0 0 4 24"
                          />
                          <path
                            fill="#555"
                            d="M44 24c0 11.046-8.954 20-20 20a19.94 19.94 0 0 1 5.945-14.23A19.94 19.94 0 0 1 44 24"
                          />
                        </g>
                      </mask>
                    </defs>
                    <path
                      fill="#494B50"
                      d="M0 0h48v48H0z"
                      mask="url(#ipTGreenNewEnergy0)"
                    />
                  </svg>
                }
              >
                Trust is crucial in technology, and we pride ourselves on being
                a dependable partner. Our solutions are built to be reliable and
                consistent, giving our clients the confidence that they can
                count on our technology to perform as expected.
              </Tab>
              <Tab
                title="I"
                subtitle="Innovation"
                image={innovationImage}
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <mask id="ipTGreenNewEnergy0">
                        <g
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="4"
                        >
                          <path d="M42.336 16C39.249 8.936 32.2 4 24 4S8.75 8.936 5.664 16" />
                          <path
                            fill="#555"
                            d="M24 14a19.94 19.94 0 0 0-6 14.283q0 .75.055 1.488A19.94 19.94 0 0 1 24 44a19.94 19.94 0 0 1 5.945-14.23q.055-.736.055-1.487A19.94 19.94 0 0 0 24 14"
                          />
                          <path
                            fill="#555"
                            d="M4 24c0 11.046 8.954 20 20 20a19.94 19.94 0 0 0-5.945-14.23A19.94 19.94 0 0 0 4 24"
                          />
                          <path
                            fill="#555"
                            d="M44 24c0 11.046-8.954 20-20 20a19.94 19.94 0 0 1 5.945-14.23A19.94 19.94 0 0 1 44 24"
                          />
                        </g>
                      </mask>
                    </defs>
                    <path
                      fill="#494B50"
                      d="M0 0h48v48H0z"
                      mask="url(#ipTGreenNewEnergy0)"
                    />
                  </svg>
                }
              >
                Staying at the forefront of technological advancements is key to
                our approach. We are dedicated to continuous improvement and
                innovation, ensuring that our products and services incorporate
                the latest technologies and ideas to provide cutting-edge
                solutions.
              </Tab>
            </TabsPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurValues;
